import React, { useEffect } from "react";
import axios from "axios";
import * as apiMethods from "../res/apiMethods.js";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";
import { DataGrid } from "@mui/x-data-grid";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";

// ─── Iconos MUI ───
import SearchIcon from '@mui/icons-material/Search';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const Search = () => {
  const [props, setProps] = React.useState({
    criteria: [],
    entity: "",
    nameSearched: false,
    clientsQuery: [],
    selectedCriteria: "",
    search: "",
  });

  const setState = (value, cb) => {
    setProps((prevState) => ({ ...prevState, ...value }));
    if (cb) {
      if (typeof cb === "function") cb();
    }
  };

  const handleChange = (prop) => (event) => {
    setProps({ ...props, [prop]: event.target.value });
  };

  // ─── Determinar entity según URL: lógica original intacta ───
  useEffect(() => {
    if (window.location.href.search("client") !== -1) {
      setState({
        criteria: [
          { slug: "document", text: "Documento del cliente" },
          { slug: "name", text: "Nombre del cliente" },
        ],
        entity: "client",
      });
    } else {
      setState({
        criteria: [
          { slug: "document", text: "Documento del cliente" },
          { slug: "id", text: "Identificador del crédito" },
          { slug: "financialCode", text: "Código de entidad financiera" },
        ],
        entity: "credit",
      });
    }
  }, []);

  // ─── Botón "Abrir" para DataGrid de clientes: lógica original ───
  const renderDetailsButton = (params) => {
    return (
      <button
        className="btn-mobilia-outline"
        style={{ fontSize: '0.74rem', padding: '0.28rem 0.65rem' }}
        onClick={() => {
          axios
            .get(apiMethods.GET_CLIENTE_DOCUMENTO + params.row.documento)
            .then((response) => {
              if (response.data.code != 0) {
                toast.error("Cliente no encontrado");
              } else {
                window.location.href = `/clients/${params.row.documento}`;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }}
      >
        Abrir <ArrowForwardIcon style={{ fontSize: '0.8rem' }} />
      </button>
    );
  };

  const clientsColumns = [
    { field: "documento", headerName: "Documento del cliente", width: 250 },
    { field: "tipoDocumento", headerName: "Tipo documento", width: 250 },
    { field: "nombre", headerName: "Nombre", width: 250 },
    {
      field: "accion",
      headerName: "Acción",
      width: 150,
      renderCell: renderDetailsButton,
    },
  ];

  // ─── Lógica de búsqueda: COMPLETAMENTE ORIGINAL ───
  const search = async (formData) => {
    let decodedPayload = JSON.parse(
      atob(window.sessionStorage.getItem("localToken").split(".")[1])
    );
    let localCredits = [];
    let localNombre;

    if (decodedPayload.role === 4) {
      let creditsResponse = await axios.get(
        apiMethods.GET_CLIENTE_DOCUMENTO + decodedPayload.username
      );
      localCredits = creditsResponse.data.client.creditos;
      localNombre = creditsResponse.data.client.nombre;
    }

    if (props.entity === "client") {
      switch (formData.selectedCriteria) {
        case "document":
          if (
            formData.search != decodedPayload.username &&
            decodedPayload.roleId == 4
          ) {
            toast.error("No tiene suficientes privilegios");
          } else {
            axios
              .get(apiMethods.GET_CLIENTE_DOCUMENTO + formData.search)
              .then((response) => {
                if (response.data.code != 0) {
                  toast.error("Cliente no encontrado");
                } else {
                  window.location.href = `/clients/${formData.search}`;
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          break;
        case "name":
          if (formData.search != localNombre && decodedPayload.roleId == 4) {
            toast.error("No tiene suficientes privilegios");
          } else {
            axios
              .get(apiMethods.GET_CLIENTE_NOMBRE + formData.search)
              .then((response) => {
                if (!response.data.clients[0]) {
                  toast.error("Cliente no encontrado");
                } else {
                  setState({
                    clientsQuery: response.data.clients,
                    nameSearched: true,
                  });
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          break;
      }
    } else {
      switch (formData.selectedCriteria) {
        case "document":
          if (
            formData.search != decodedPayload.username &&
            decodedPayload.roleId == 4
          ) {
            toast.error("No tiene suficientes privilegios");
          } else {
            axios
              .get(apiMethods.GET_CLIENTE_DOCUMENTO + formData.search)
              .then((response) => {
                if (response.data.code != 0) {
                  toast.error("El documento no existe");
                } else {
                  window.location.href = `/clients/${formData.search}`;
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          break;
        case "id":
          if (
            !localCredits.find((element) => element == formData.search) &&
            decodedPayload.roleId == 4
          ) {
            toast.error("No tiene suficientes privilegios");
          } else {
            axios
              .get(apiMethods.GET_CREDITO_ID + formData.search)
              .then((response) => {
                if (response.data.code != 0) {
                  toast.error("Crédito no encontrado");
                } else {
                  window.sessionStorage.setItem(
                    "localDocument",
                    formData.search
                  );
                  window.location.href = `/credits/${formData.search}`;
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          break;
        case "name":
          if (formData.search != localNombre && decodedPayload.roleId == 4) {
            toast.error("No tiene suficientes privilegios");
          } else {
            axios
              .get(apiMethods.GET_CLIENTE_NOMBRE + formData.search)
              .then((response) => {
                if (
                  response.data.code != 0 ||
                  response.data.clients.length == 0
                ) {
                  toast.error("Cliente no encontrado");
                } else {
                  setState({
                    clientsQuery: response.data.clients,
                    nameSearched: true,
                  });
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          break;
        case "financialCode":
          if (
            !localCredits.find((element) => element == formData.search) &&
            decodedPayload.roleId == 4
          ) {
            toast.error("No tiene suficientes privilegios");
          } else {
            axios
              .get(apiMethods.GET_CREDITO_FINANCIAL_CODE + formData.search)
              .then((response) => {
                if (response.data.credits) {
                  window.sessionStorage.setItem(
                    "localDocument",
                    response.data.credits.id
                  );
                  window.location.href = `/credits/${response.data.credits.id}`;
                } else {
                  toast.error("Crédito no encontrado");
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          break;
      }
    }
  };

  const onError = (errors, e) => {
    for (let error in errors) {
      toast.error(errors[error].message);
    }
  };

  const {
    control,
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  // ─── Acceso denegado si no hay token ───
  if (!window.sessionStorage.getItem("localToken")) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Acceso denegado</div>;
  }

  return (
    <>
      <ToastContainer />
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>

        {/* ─── Header con título y botones de tipo ─── */}
        <div className="section-header">
          <div className="title-group">
            <h1>Consulta & Búsqueda Avanzada</h1>
            <p>Localiza expedientes de créditos y titulares en la base de datos central</p>
          </div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <a
              href="/search/credits"
              className={props.entity === 'credit' ? 'btn-mobilia-primary' : 'btn-mobilia-secondary'}
              style={{ textDecoration: 'none' }}
            >
              Buscar Créditos
            </a>
            <a
              href="/search/clients"
              className={props.entity === 'client' ? 'btn-mobilia-primary' : 'btn-mobilia-secondary'}
              style={{ textDecoration: 'none' }}
            >
              Buscar Clientes
            </a>
          </div>
        </div>

        {/* ─── Panel de Filtros ─── */}
        <div className="glass-panel" style={{ padding: '1.85rem', display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#090d16', fontWeight: 600, fontSize: '0.92rem' }}>
            <FilterAltIcon style={{ color: '#cb1016', fontSize: '1.15rem' }} /> Criterios de Búsqueda
          </div>

          <form onSubmit={handleSubmit(search, onError)} style={{ display: 'grid', gridTemplateColumns: '240px 1fr auto', gap: '1rem', alignItems: 'center' }}>
            <TextField
              select
              size="small"
              label="Filtrar por"
              defaultValue="document"
              {...register("selectedCriteria")}
              onChange={(e) => {
                handleChange("selectedCriteria")(e);
                setState({ nameSearched: false });
              }}
              InputProps={{ style: { background: 'rgba(255, 255, 255, 0.7)', borderRadius: '10px' } }}
            >
              {props.criteria.map((criteria) => (
                <MenuItem key={criteria.slug} value={criteria.slug}>
                  {criteria.text}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              size="small"
              label="Término de Consulta"
              placeholder="Escribe el documento, nombre o ID a buscar..."
              {...register("search")}
              onChange={handleChange("search")}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{ color: '#94a3b8', fontSize: '1.2rem' }} />
                  </InputAdornment>
                ),
                style: { background: 'rgba(255, 255, 255, 0.7)', borderRadius: '10px' }
              }}
            />

            <button
              type="submit"
              className="btn-mobilia-primary"
              style={{ height: '40px', padding: '0 1.5rem' }}
            >
              Buscar
            </button>
          </form>
        </div>

        {/* ─── Resultados de Búsqueda (DataGrid original) ─── */}
        {props.entity === "client" && props.nameSearched === true && (
          <div className="glass-panel" style={{ padding: '1.85rem', display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ fontSize: '1.05rem', fontWeight: 700, margin: 0, color: '#090d16' }}>
                Resultados encontrados ({props.clientsQuery.length})
              </h3>
              <span style={{ fontSize: '0.78rem', color: '#64748b' }}>
                Base de datos sincronizada
              </span>
            </div>

            <div style={{ height: 300, width: "100%" }}>
              <DataGrid
                rows={props.clientsQuery}
                columns={clientsColumns}
                pageSize={5}
                getRowId={(row) => row._id}
                rowsPerPageOptions={[5, 10]}
                disableSelectionOnClick
                sx={{
                  border: '1px solid #EAECF0',
                  borderRadius: '14px',
                  '& .MuiDataGrid-columnHeaders': {
                    background: '#F9FAFB',
                    borderBottom: '1px solid #EAECF0',
                    fontSize: '0.78rem',
                    fontWeight: 600,
                    color: '#667085',
                    textTransform: 'uppercase',
                    letterSpacing: '0.04em'
                  },
                  '& .MuiDataGrid-cell': {
                    fontSize: '0.85rem',
                    color: '#111111',
                    borderBottom: '1px solid #F2F4F7'
                  },
                  '& .MuiDataGrid-row:hover': {
                    background: '#F9FAFB'
                  }
                }}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Search;